<template>
<!-- 数字产业·农业规划 -->
  <div class="agricultural_planning">
    <div v-for="(item, index) in agricultural" :key="index" :class="item.Class" @click="click_agricultural(item.Class, index, item.cont)">
      {{ item.cont }}
    </div>
  </div>
</template>

<script>
name: "agricultural_planning";
export default {
  data() {
    return {
      agricultural: [
        {
          Class: "cont_jj",
          cont: "经济开发区",
          boolen_val:false
        },
        {
          Class: "cont_st",
          cont: "生态发展区",
          boolen_val:false
        },
      ],
    };
  },
  methods:{
    load(){
      var height = document.body.clientHeight / 2;
      $(".agricultural_planning").css("top", height + 'px');
    },
    click_agricultural:function(Class, e, name){
      this.agricultural[e].boolen_val = !this.agricultural[e].boolen_val
      let vnt = this.agricultural[e].boolen_val;
      let vn = !this.agricultural[e].boolen_val;
      if(vnt){
        plMap.visibleDigitalIndustrial_LegendLayer(plMap.digitalIndustrial.curLayerId,e);
      $(".agricultural_planning").children().css("border", "1px solid #fff");
        $("." + Class).css("border", "3px solid #f00");
        this.$set(this.agricultural, "boolen_val", false)
      }
      if(vn){
        $(".agricultural_planning").children().css("border", "1px solid #fff");
        this.$set(this.agricultural, "boolen_val", true);
        plMap.removeDigitalIndustrial_LegendLayer()
      }
      
    }
  },
  mounted:function(){
    this.load()
  }
};
</script>

<style scoped lang="less">
.agricultural_planning{
  position: absolute;
    right: 1%;
    transform: translate(0, -50%);
}
.cont_jj,
.cont_st {
  cursor: pointer;
  width: 66px;
  height: 30px;
  border: 1px solid #fff;
  margin: 5px 0;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
}
.cont_jj {
  background: url("../../assets/agricultural_planning/经济开发区.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
.cont_st {
  background: url("../../assets/agricultural_planning/生态发展区.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
</style>


// WEBPACK FOOTER //
// src/components/cutline/agricultural_planning.vue